var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active),expression:"active"}],staticClass:"tw-text-md lg:tw-text-xl tw-space-y-1 tw-absolute"},[_vm._t("default"),_vm._v(" "),_c('p',{staticClass:"tw-font-bold tw-text-md tw-mt-3"},[_vm._v("\n\t\t\t"+_vm._s(_vm.title)+"\n\t\t")])],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }